import { render } from "./ReceiveMessage.vue?vue&type=template&id=07fb2a28"
import script from "./ReceiveMessage.vue?vue&type=script&lang=js"
export * from "./ReceiveMessage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__